import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChildren
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { ROUTE_ANIMATIONS_ELEMENTS } from '../../../../core/core.module';
import { State } from '../../../vista-usuario/vista-usuario.state';
import { SitioProcesamiento } from '../../entity-sitios-procesamiento/sitios-procesamiento.model';
import { RegistroActividadSitioProcesamientoFormComponent } from '../registro-actividad-sitio-procesamiento-form.component';
import { IBaseTable } from 'projects/registro-personas-empresas/src/app/shared/util/base-table.util';
import { MatDialog } from '@angular/material/dialog';
import {
  entitySitiosProcesamientoAddRequest,
  entitySitiosProcesamientoDeleteRequest
} from '../../entity-sitios-procesamiento/sitios-procesamiento.actions';
import { RegistroActividadSitioProcesamientoFormContainerComponent } from '../registro-actividad-sitio-procesamiento-form-container/registro-actividad-sitio-procesamiento-form-container.component';
import { RegistroActividadMaquinasMovilesFormContainerComponent } from '../../registro-actividad-maquinas-moviles/components/registro-actividad-maquinas-moviles-form-container/registro-actividad-maquinas-moviles-form-container.component';
import { MaquinaMovil } from '../../entity-maquinas-moviles/entity-maquinas-moviles.model';
import { entityMaquinaMovilDeleteRequest } from '../../entity-maquinas-moviles/entity-maquinas-moviles.actions';
import { FormActionType } from '@rpe/registro-personas-empresas-lib';
import { ConfirmDialogComponent } from 'projects/registro-personas-empresas/src/app/shared/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'rpe-registro-actividad-sitios-procesamiento-tabs-form',
  templateUrl:
    './registro-actividad-sitios-procesamiento-tabs-form.component.html',
  styleUrls: [
    './registro-actividad-sitios-procesamiento-tabs-form.component.scss'
  ]
})
export class RegistroActividadSitiosProcesamientoTabsFormComponent
  implements OnInit, OnDestroy
{
  @ViewChildren(RegistroActividadSitioProcesamientoFormComponent)
  registrosActividadSitioProcesamientoForm: QueryList<RegistroActividadSitioProcesamientoFormComponent>;

  @Input() set actividadesSitioProcesamientoTabsInput(data: {
    sitios: SitioProcesamiento[];
    maquinasMoviles: MaquinaMovil[];
  }) {
    this.sitioProcesamientoTable = {
      ...this.sitioProcesamientoTable,
      dataSource: data.sitios
    };
    this.maquinaMovilTable = {
      ...this.maquinaMovilTable,
      dataSource: data.maquinasMoviles.map((item: MaquinaMovil) => ({
        ...item,
        marca: item.equipamientos?.[0]?.marca || 'N/A',
        modelo: item.equipamientos?.[0]?.modelo || 'N/A'
      }))
    };
  }

  @Output() showSPEvent: EventEmitter<boolean> = new EventEmitter<boolean>(
    true
  );

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  subscriptions: Subscription[] = [];

  maquinaMovilTable: IBaseTable<MaquinaMovil> = {
    dataSource: [],
    columns: [
      {
        caption: 'Número',
        field: {
          key: 'id'
        }
      },
      {
        caption: 'Marca',
        field: {
          key: 'marca'
        }
      },
      {
        caption: 'Modelo',
        field: {
          key: 'modelo'
        }
      }
    ],
    actions: [
      {
        name: 'Editar',
        icon: '',
        hide: () => {
          return true;
        },
        action: (element: MaquinaMovil) => {
          this.dialog.open(
            RegistroActividadMaquinasMovilesFormContainerComponent,
            {
              data: {
                maquinaMovil: element,
                type: FormActionType.Update
              },
              height: '90vh',
              width: '900px'
            }
          );
        }
      },
      {
        name: 'Borrar',
        icon: '',
        hide: () => {
          return true;
        },
        action: ($event: MaquinaMovil) => {
          this.deleteMaquinaMovil($event);
        }
      }
    ]
  };

  sitioProcesamientoTable: IBaseTable<SitioProcesamiento> = {
    dataSource: [],
    columns: [
      {
        caption: 'Número',
        field: {
          key: 'id'
        }
      },
      {
        caption: 'Nombre',
        field: {
          key: 'nombre'
        }
      }
    ],
    actions: [
      {
        name: 'Editar',
        icon: '',
        hide: () => {
          return true;
        },
        action: (element: SitioProcesamiento) => {
          this.dialog.open(
            RegistroActividadSitioProcesamientoFormContainerComponent,
            {
              data: {
                sitioProcesamiento: element
              },
              height: '90vh',
              width: '900px'
            }
          );
        }
      },
      {
        name: 'Borrar',
        icon: '',
        hide: () => {
          return true;
        },
        action: ($event: SitioProcesamiento) => {
          this.deleteSitioProcesamiento($event);
        }
      }
    ]
  };

  constructor(private store: Store<State>, private dialog: MatDialog) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onGuardar() {
    this.dialog.open(
      RegistroActividadSitioProcesamientoFormContainerComponent,
      {
        data: {
          sitioProesamiento: null
        },
        height: '90vh',
        width: '900px'
      }
    );
  }

  deleteSitioProcesamiento($event: SitioProcesamiento): void {
    const ref = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Eliminar sitio procesamiento',
        contentText: `¿Está seguro que desea eliminar el sitio de procesamiento?`,
        submitText: 'Eliminar',
        cancelText: 'Cancelar',
        cancelColor: 'primary'
      }
    });

    ref.afterClosed().subscribe((result) => {
      if (result) {
        this.store.dispatch(
          entitySitiosProcesamientoDeleteRequest({
            item: $event
          })
        );
      }
    });
  }

  deleteMaquinaMovil($event: MaquinaMovil): void {
    const ref = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Eliminar máquina móvil',
        contentText: `¿Está seguro que desea eliminar la máquina móvil?`,
        submitText: 'Eliminar',
        cancelText: 'Cancelar',
        cancelColor: 'primary'
      }
    });

    ref.afterClosed().subscribe((result) => {
      if (result) {
        this.store.dispatch(
          entityMaquinaMovilDeleteRequest({
            item: $event
          })
        );
      }
    });
  }

  onAddMaquinaMovil() {
    this.dialog.open(RegistroActividadMaquinasMovilesFormContainerComponent, {
      data: {
        maquinaMovil: null,
        type: FormActionType.Add
      },
      height: '90vh',
      width: '900px'
    });
  }

  onCancel() {
    this.showSPEvent.emit(false);
  }
}
